import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import Interactable from '../../../Component/Interactable';
import CardSystem from '../../Card/CardSystem';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import {
    showCardScoreEffectAt,
    showCardCoinEffectAt,
} from '../CardAnimationHelper';
import Point from 'Utility/Point';
import { delay } from '../../../Utility/Task/TaskQueue';
import { Easing } from '@tweenjs/tween.js';

type Meta = {
    system: CardSystem;
    cardScore: number;
    coinsCollected: number;
    playAudio?: boolean;
    forceScale?: boolean;
    target?: Point;
    delay?: number;
}

export class ConnectedCardMatch extends AnimationClip<Meta> {
    public* execute(card: BaseCard, meta: Meta): IterableIterator<number> {
        if (meta.delay) {
            yield* delay(meta.delay);
        }

        const { playAudio = true, forceScale = true, target = Point.Zero } = meta;
        if (playAudio) {
            let streakAudioIndex = meta.system.store.getState().levelState
                .cardsState.matchSequence.length;
            if (streakAudioIndex > 10) {
                streakAudioIndex = 10;
            }

            PlaySound(
                [
                    'rising-tones1',
                    'rising-tones2',
                    'rising-tones3',
                    'rising-tones4',
                    'rising-tones5',
                    'rising-tones6',
                    'rising-tones7',
                    'rising-tones8',
                    'rising-tones9',
                    'rising-tones10',
                ][streakAudioIndex - 1]
            );
        }

        const transform = card.getComponent(TransformComponent);
        const interactable = card.getComponent(Interactable);
        interactable.enabled = false;

        if (meta.coinsCollected) {
            showCardCoinEffectAt(
                meta.system.scene,
                card.parent,
                meta.coinsCollected,
                transform.position.clone(),
            );

            meta.system.scene.emit('UpdateScoreProgress');
        } else {
            showCardScoreEffectAt(
                meta.system.scene,
                card.parent,
                meta.cardScore,
                transform.position.clone(),
            );
        }

        // Fix scale in case interrupting flip animation.
        if (forceScale) {
            transform.scale.copy(Point.One);
        }

        const tween = this
            .getTween(transform)
            .to({
                x: target.x,
                y: target.y,
                rotation: [Math.atan2(target.y - transform.y, target.x - transform.x) - Math.PI / 2, 0],
            }, 600)
            .easing(Easing.Sinusoidal.InOut);

        yield* this.startTween(tween);
    }
}
